import { en } from './en';
import { ar } from './ar';
import { fr } from './fr';
import { ru } from './ru';
import { ur } from './ur';
import { fa } from './fa';

export const languages = {
  en: {
    name: 'English',
    code: 'en',
    dir: 'ltr',
    content: en
  },
  ar: {
    name: 'العربية',
    code: 'ar',
    dir: 'rtl',
    content: ar
  },
  fr: {
    name: 'Français',
    code: 'fr',
    dir: 'ltr',
    content: fr
  },
  ru: {
    name: 'Русский',
    code: 'ru',
    dir: 'ltr',
    content: ru
  },
  ur: {
    name: 'اردو',
    code: 'ur',
    dir: 'rtl',
    content: ur
  },
  fa: {
    name: 'فارسی',
    code: 'fa',
    dir: 'rtl',
    content: fa
  }
};

export const defaultLanguage = 'en';

export const getLanguage = (code) => {
  return languages[code] || languages[defaultLanguage];
};

export const getLanguageList = () => {
  return Object.values(languages).map(lang => ({
    code: lang.code,
    name: lang.name,
    dir: lang.dir
  }));
}; 